module.exports = "/_next/static/images/Frame2-e71144f67e76e3318a4922a818581a28.png";